module.exports = __webpack_public_path__ + "static/media/platform-screen2.f70c8411.jpg";